import {getTodayStartTime} from 'shared/utils/dateTime';
import {spentWithinPeriod, addedWithinPeriod} from 'core/History';
import {couldSpendSinceStart} from 'core/LifeCycle';
import {customPeriod} from 'core/Period';

export function saved(budget: Budget, history: HistoryLog): MoneyAmount {
  const todayStart = getTodayStartTime();
  const tillToday = customPeriod({from: budget.startDate, to: todayStart});

  const couldSpend = couldSpendSinceStart(budget);
  const spent = spentWithinPeriod(history, tillToday);
  const added = addedWithinPeriod(history, tillToday);

  return Math.max(Math.min(budget.initial, couldSpend) - spent + added, 0);
}
